import ArrowLeftOutlined from '@ant-design/icons/ArrowLeftOutlined';
import LockOutlined from '@ant-design/icons/LockOutlined';
import RestOutlined from '@ant-design/icons/RestOutlined';
import SafetyOutlined from '@ant-design/icons/SafetyOutlined';

const cofre = {
  id: 'group-cofre',
  title: 'Cofre de Senhas',
  type: 'group',
  children: [
    {
      id: 'back-to-core-cofre',
      title: 'Voltar ao Principal',
      type: 'item',
      url: '/dashboard',
      icon: ArrowLeftOutlined,
      breadcrumbs: false
    },
    {
      id: 'cofre-credenciais',
      title: 'Credenciais',
      type: 'item',
      url: '/cofre/credenciais',
      icon: LockOutlined,
      permissions: ['cofre.acessar'],
      breadcrumbs: false
    },
    {
      id: 'cofre-lixeira',
      title: 'Lixeira',
      type: 'item',
      url: '/cofre/lixeira',
      icon: RestOutlined,
      permissions: ['cofre.acessar'],
      breadcrumbs: false
    },
    {
      id: 'cofre-auditoria',
      title: 'Auditoria',
      type: 'item',
      url: '/cofre/auditoria',
      icon: SafetyOutlined,
      permissions: ['cofre.auditoria.view'],
      breadcrumbs: false
    }
  ]
};

export default cofre;
